import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { Observable } from 'rxjs';
import { Country } from '../models/country.model';

@Injectable({
	providedIn: 'root'
})
export class CountryService {

	constructor(private http: HttpClient) { }

	public getCountries(): Observable<Country[]> {
		return this.http.get<Country[]>(BackendAPI.staticDataCountries);
	}
}
